<template>
  <div class="date-box">
    <div class="date-show">{{ format(currentDate) }}</div>
    <div class="date-arrow arrow-prev">
      <van-icon name="play" style="rotate:180deg;" @click="prev" />
    </div>
    <div class="date-arrow arrow-next">
      <van-icon name="play" @click="next" :class="hasNext()?'':'disabled'"/>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    value: {
      type: String,
      default: moment(new Date()).format("YYYY-MM"),
    },
  },
  computed: {
    currentDate() {
      return this.value;
    },
  },
  methods: {
    format(date){
      return moment(date).format("YYYY年MM月")
    },
    prev() {
      this.$emit(
        "input",
        moment(this.value)
          .subtract(1, "months")
          .format("YYYY-MM")
      );
      this.$emit('change',moment(this.value)
            .add(1, "months")
            .format("YYYY-MM"))
    },
    next() {
      if (
        new Date(this.value) < new Date(moment(new Date()).format("YYYY-MM"))
      ) {
        this.$emit(
          "input",
          moment(this.value)
            .add(1, "months")
            .format("YYYY-MM")
        );
        this.$emit('change',moment(this.value)
            .add(1, "months")
            .format("YYYY-MM"))
      }
    },
    hasNext(){
      if (
        new Date(this.value) < new Date(moment(new Date()).format("YYYY-MM"))
      ){
        return true
      }else{
        return false
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.date-box {
  display: flex;
  // justify-content: space-around;
  align-items: center;
  color: #333;
  font-size: 0.8rem;
  font-weight: bold;
}
.date-show{
  
  letter-spacing: 0.3rem;
}
.date-arrow{
  padding: 0 1rem;
  color: #333;
  .disabled{
    color: #ccc;
  }
}
</style>
